import { render, staticRenderFns } from "./MantenedorGrid.vue?vue&type=template&id=5922d3c9&"
import script from "./MantenedorGrid.vue?vue&type=script&lang=ts&"
export * from "./MantenedorGrid.vue?vue&type=script&lang=ts&"
import style0 from "./MantenedorGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5922d3c9', component.options)
    } else {
      api.reload('5922d3c9', component.options)
    }
    module.hot.accept("./MantenedorGrid.vue?vue&type=template&id=5922d3c9&", function () {
      api.rerender('5922d3c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Grid/MantenedorGrid.vue"
export default component.exports